// extracted by mini-css-extract-plugin
export default {"pagger_wrapper":"t476rIVwbkRxU1ntwnbm","paggerWrapper":"t476rIVwbkRxU1ntwnbm","pagger_item":"tS27J78MzCW51mR4y8r4","paggerItem":"tS27J78MzCW51mR4y8r4"};